"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_SIDEBAR = 'SHOW_SIDEBAR';
exports.MINIMIZE_SIDEBAR = 'MINIMIZE_SIDEBAR';
exports.SHOW_ASIDE = 'SHOW_ASIDE';
exports.ENABLE_DARKMODE = 'TOGGLE_DARKMODE';
exports.ADD_NOTIFICATION = 'ADD_NOTIFICATION';
exports.UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
exports.REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';